<template>
  <canvas ref="canvas" class="video-canvas" />
</template>

<script setup>
const canvas = ref(null);
const { initCanvas, destroy } = useVideoCanvas();
const { $gsap: gsap } = useNuxtApp();

const resize = () => {
  if (!canvas.value) return;

  canvas.value.width = window.innerWidth * window.devicePixelRatio;
  canvas.value.height = window.innerHeight * window.devicePixelRatio;
  canvas.value.style.width = `${window.innerWidth}px`;
  canvas.value.style.height = `${window.innerHeight}px`;
};

onMounted(() => {
  nextTick(() => {
    resize();
    initCanvas(canvas.value, gsap);
    window.addEventListener('resize', resize);
  });
});

onUnmounted(() => {
  window.removeEventListener('resize', resize);
  destroy();
});
</script>

<style lang="scss" scoped>
.video-canvas {
  position: fixed;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 10;
  width: 100vw;
  height: var(--height);
  background: transparent;
}
</style>
